import React, { Component } from 'react';
import Menu from './Menu';
import CardBrandIcon from 'src/components/Shared/CardBrandIcon';
import PaymentStatusBadge from 'src/components/Shared/PaymentStatusBadge';
import { formatDateTime, formatAmount } from 'src/Common/utils';

export default class Payments extends Component {
    render() {
        const { nsu, createdAt, card, amount, installments, installmentsAmount, paymentStatus, paymentType } = this.props;
        let trunc = 'Pagemento realizado por boleto', brand = 'slip';
        if (card !== null) {
           trunc = card.trunc
           brand = card.brand
        }
        return (
            <tr>
                <td>{nsu}</td>
                <td>{formatDateTime(createdAt)}</td>
                <td>
                    <CardBrandIcon brand={brand} />
                </td>
                <td>{trunc}</td>
                <td>{paymentType}</td>
                <td>{formatAmount(amount)}</td>
                <td>{installments}x {formatAmount(installmentsAmount)}</td>
                <td>
                    <PaymentStatusBadge status={paymentStatus} />
                </td>
                <td className="text-right">
                    <Menu />
                </td>
            </tr>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Pages/Orders/Details/Payments/TableRow.js